/**
 * core
 */
import { ComparisonOperator, ComparisonOperatorType } from '@core/enums/comparison-operator';

/**
 * Default message per comparison operator, used by {@link DateValidator.compare} whenever the
 * caller does not pass its own `i18nKey`.
 *
 * Keyed by the raw symbol (`'<'`, `'<='`, …) so both a {@link ComparisonOperator} member and a
 * plain literal resolve to the same entry.
 *
 * Wording is deliberately generic ("start"/"end" value) so the same key serves dates, times and
 * datetimes; a field-specific message stays the caller's job via `i18nKey`.
 */
export const COMPARE_I18N_KEYS: Readonly<Record<ComparisonOperatorType, string>> = {
    [ComparisonOperator.LessThan]: 'FORM.VALIDATION.COMPARE.LESS_THAN',
    [ComparisonOperator.LessThanOrEqual]: 'FORM.VALIDATION.COMPARE.LESS_THAN_OR_EQUAL',
    [ComparisonOperator.GreaterThan]: 'FORM.VALIDATION.COMPARE.GREATER_THAN',
    [ComparisonOperator.GreaterThanOrEqual]: 'FORM.VALIDATION.COMPARE.GREATER_THAN_OR_EQUAL',
    [ComparisonOperator.Equal]: 'FORM.VALIDATION.COMPARE.EQUAL',
    [ComparisonOperator.NotEqual]: 'FORM.VALIDATION.COMPARE.NOT_EQUAL',
};
